module.exports = "<h2 class=\"subtitle\">{{vm.title}}</h2>\n\n<region-selection\n        selected=\"vm.region\"\n        regions=\"vm.regions\"\n        columns=\"3\"\n        on-select=\"vm.selectRegion(region)\"\n        on-keydown=\"vm.onRegionKeyDown(event, region, index)\"></region-selection>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/otherRegions/otherRegions.html
 ** module id = 171
 ** module chunks = 0
 **/